import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nContext";

const Stats = () => {
  const { dict } = useI18n();
  const s = dict.stats;

  return (
    <section data-testid="stats-section" className="py-16 md:py-20 bg-[hsl(var(--background))]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-[11px] font-semibold tracking-[0.18em] text-[hsl(var(--accent))] uppercase text-center">
          {s.eyebrow}
        </div>
        <div className="gold-rule mt-4 max-w-32 mx-auto" />

        <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4">
          {s.items.map((it, idx) => (
            <motion.div
              key={it.label}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.45, delay: idx * 0.05 }}
              data-testid={`stats-tile-${idx}`}
              className="rounded-2xl border border-slate-200 bg-white p-6 text-center card-lift"
            >
              <div className="font-display text-4xl md:text-5xl text-[hsl(var(--primary))] leading-none">
                {it.value}
              </div>
              <div className="mt-2 inline-flex items-center gap-1.5 text-[12px] uppercase tracking-[0.14em] text-slate-500">
                <span className="h-1.5 w-1.5 rounded-full bg-[hsl(var(--accent))]" />
                {it.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
